/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {LabelSmall} from 'baseui/typography'
import React from 'react'
import {defaultFieldValues} from '../../utils/config'

const UserField = ({label, field}) => {
  const labelProps = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }

  return (
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            display: 'flex',
            alignItems: 'baseline',
            marginLeft: $theme.sizing.scale800,
            marginRight: $theme.sizing.scale800,
          }),
        },
      }}
    >
      <LabelSmall
        $as="pre"
        {...labelProps}
        overrides={{
          Block: {
            style: ({$theme}) => ({
              color: $theme.colors.mono600,
              minWidth: $theme.sizing.scale3200,
            }),
          },
        }}
      >
        {label}:
      </LabelSmall>
      <LabelSmall $as="pre" {...labelProps}>
        {field || defaultFieldValues.emptyField}
      </LabelSmall>
    </Block>
  )
}

export default UserField
